/**
 * Return the task specified by an event. If the event has a `taskId`, it will be used to look up
 * the task; if it does not have a `taskId`, but has a `matchId` function, that will be used instead.
 * @param context - {@link TaskContext}
 * @param event - {@link TaskEvent}
 * @returns the {@link UnknownTask} specified by the event; or null if no match is found
 */
export const getTask = (
    context: TaskContext,
    event: TaskEvent,
): UnknownTask | null => {
    const {
        value: { taskId },
    } = event;
    const matchId = event.value?.matchId ?? null;

    let task = null;
    const tasks = Array.from(context.tasks.values());

    if (taskId) {
        task =
            tasks.find(
                (currentTask: UnknownTask): boolean =>
                    currentTask.taskId === taskId,
            ) ?? null;
    } else if (matchId) {
        task =
            tasks.find((currentTask: UnknownTask): boolean =>
                matchId(currentTask),
            ) ?? null;
    }

    return task;
};
